import React, { useCallback, useEffect, useState, Fragment } from 'react';
// import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Row, Col, Table } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

// import ProfileAvatar from "../../../../components/ui/ProfileAvatar";
import CustomTooltip from "../../../../components/ui/Tooltip";
import NoDataFound from "../../../../components/ui/NoDataFound";
import Pagination from "../../../../components/ui/Pagination";
// import PaginationArrow from "../../../../components/ui/PaginationArrow";
import SkeletonLoader from "../../../../components/ui/SkeletonLoader";
import SideModal from "../../../../components/ui/SideModal";

import DownloadReport from "../../../../components/PostLogin/ScanInfo/Reports/DownloadReport";

import { searchIcon, scanHistoryDownloadReportIcon, sendIcon } from "../../../../utils/icons";
import { getOrganizationImageUrl, getloggedInUserType } from "../../../../utils/util";

import { useSelector, useDispatch } from "react-redux";
import { getPortfolioRiskList, getPortfolioStatus } from "../../../../store/actions/scanInfoAction";

const ChildPagination = ({ orgId, filteredChildren, totalAll, page, perPage, searchVal, onPageChange, onPerPageChange, onSearch }) => {

    const SearchIcon = ({ size = 16, color = "#475569" }) => (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    );

    const total = filteredChildren.length;
    const totalPages = Math.ceil(total / perPage);
    const start = (page - 1) * perPage + 1;
    const end = Math.min(page * perPage, total);

    const renderPageButtons = () => {
        const buttons = [];
        if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++)
            buttons.push(<button key={i} className={`page-btn ${i === page ? "active" : ""}`} onClick={() => onPageChange(orgId, i)}>{i}</button>);
        } else {
            buttons.push(<button key={1} className={`page-btn ${1 === page ? "active" : ""}`} onClick={() => onPageChange(orgId, 1)}>1</button>);
            if (page > 3) buttons.push(<span key="e1" className="ellipsis">…</span>);
            for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++)
                buttons.push(<button key={i} className={`page-btn ${i === page ? "active" : ""}`} onClick={() => onPageChange(orgId, i)}>{i}</button>);
            if (page < totalPages - 2) buttons.push(<span key="e2" className="ellipsis">…</span>);
            buttons.push(<button key={totalPages} className={`page-btn ${totalPages === page ? "active" : ""}`} onClick={() => onPageChange(orgId, totalPages)}>{totalPages}</button>);
        }
        return buttons;
    };

    return (
        <tr className="child-row pagination-row">
            <td colSpan="11" style={{ padding: "8px 12px 14px 52px" }}>
                <div className="pagination-bar">
                <span className="pagination-info">
                    {start}–{end} of {total}{total < totalAll ? ` (filtered from ${totalAll})` : ""} domains
                </span>
                <div className="pagination-controls">
                    <button className={`page-btn ${page <= 1 ? "disabled" : ""}`} onClick={() => onPageChange(orgId, page - 1)}>‹</button>
                    {renderPageButtons()}
                    <button className={`page-btn ${page >= totalPages ? "disabled" : ""}`} onClick={() => onPageChange(orgId, page + 1)}>›</button>
                </div>
                <select className="per-page-select" value={perPage} onChange={(e) => onPerPageChange(orgId, parseInt(e.target.value))}>
                    {[5, 10].map((n) => <option key={n} value={n}>{n} / page</option>)}
                </select>
                <div className="domain-search-wrap">
                    <SearchIcon size={13} />
                    <input className="domain-search" type="text" placeholder="Search domains..." value={searchVal}
                    onChange={(e) => onSearch(orgId, e.target.value)} />
                </div>
                </div>
            </td>
        </tr>
    );
}

const PortfolioDashboard = () => {

    const portfolioRiskListResponse = useSelector((state) => state.scanInfo?.portfolioRiskList);
    const portfolioDomainListResponse = useSelector((state) => state.scanInfo?.portfolioDomainList);
    const customerSelectedValue = useSelector((state) => state?.scanInfo?.portfolioCustomerSelected);
    const portfolioStatusResponse = useSelector((state) => state?.scanInfo?.portfolioStatus);

    const navigate = useNavigate()

    const dispatch = useDispatch();

    
    // const [searchPortfolioValue, setSearchPortfolioValue] = useState("")
    // const [listCurrentPage, setListCurrentPage] = useState(1);
    // const [listLoading, setListLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // const [selectedOrganization, setSelectedOrganization] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [statsLoading, setStatsLoading] = useState(false);
    const [selectedDomain, setSelectedDoamin] = useState("");
    const [showDownloadReport, setShowDownloadReport] = useState(false);



    const [portfoliList, setPortfolioList] = useState([]);

    // const [searchTerm, setSearchTerm] = useState("");
    const [expanded, setExpanded] = useState({});
    const [childPages, setChildPages] = useState({});
    const [childPerPages, setChildPerPages] = useState({});
    const [childSearch, setChildSearch] = useState({});

    //heat map values
    const [criticalList, setCriticalList] = useState([]);
    const [highList, setHighList] = useState([]);
    const [mediumList, setMediumList] = useState([]);
    const [mediumTwo, setMediumTwo] = useState([]);
    const [lowList, setLowList] = useState([]);
    const [moreThan800, setMoreThan800] = useState([]);

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const DEFAULT_PER_PAGE = 5;
    const repColor = (s) => !s ? "#888" : s >= 80 ? "#3FA600" : s >= 75 ? "#F6DC6C" : s >= 50 ? "#F2A16B" : "#EE6862";

    const ChevronIcon = ({ expanded }) => (
        <svg width="20" height="20" viewBox="0 0 12 12" fill="none"
            style={{ transform: expanded ? "rotate(90deg)" : "rotate(0deg)", cursor: "pointer", transition: "transform 0.25s ease" }}>
            <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );

    const ExpandToggle = ({ hasChildren, expanded, onClick }) => {
        if (!hasChildren) return <span className="expand-spacer" />;
        return (
            <span className={`expand-toggle ${expanded ? "expanded" : ""}`} onClick={onClick}>
            <ChevronIcon expanded={expanded} />
            </span>
        );
    }

    const toggleOrg = (id) => {
        setExpanded((prev) => {
        const next = { ...prev, [id]: !prev[id] };
        if (next[id] && !childPages[id]) setChildPages((p) => ({ ...p, [id]: 1 }));
            return next;
        });
    };

    // const expandAll = () => {
    //     const next = {};
    //     const pages = { ...childPages };
    //     portfoliList?.results?.forEach((o) => { if (o.children?.length) { next[o.id] = true; if (!pages[o.id]) pages[o.id] = 1; } });
    //     setExpanded(next);
    //     setChildPages(pages);
    // };

    // const collapseAll = () => setExpanded({});

    const getFilteredChildren = useCallback((orgId) => {
        const org = portfoliList.results?.find((o) => o.organization_id === orgId);
        if (!org?.domain_list) return [];
        const term = (childSearch[orgId] || "").toLowerCase();
        return term ? org.domain_list.filter((c) => c.domain.toLowerCase().includes(term)) : org.domain_list;
    }, [childSearch, portfoliList]);
    

    const goToChildPage = (orgId, page) => {
        const pp = childPerPages[orgId] || DEFAULT_PER_PAGE;
        const fc = getFilteredChildren(orgId);
        const tp = Math.ceil(fc.length / pp);
        if (page < 1 || page > tp) return;
        setChildPages((p) => ({ ...p, [orgId]: page }));
    };

    const changePerPage = (orgId, val) => {
        setChildPerPages((p) => ({ ...p, [orgId]: val }));
        setChildPages((p) => ({ ...p, [orgId]: 1 }));
    };

    const searchDomains = (orgId, val) => {
        setChildSearch((p) => ({ ...p, [orgId]: val }));
        setChildPages((p) => ({ ...p, [orgId]: 1 }));
    };

    const ReputationRing = ({ score }) => {
        const c = repColor(score);
        const d = (score / 100) * 94.2;
        return (
            <div className="reputation">
                <svg width="30" height="30" viewBox="0 0 36 36">
                    <circle cx="18" cy="18" r="15" fill="none"
                        stroke={score ? "rgba(255,255,255,0.06)" : "#ccc"}
                        strokeWidth="3"/>
                    <circle cx="18" cy="18" r="15" fill="none" stroke={c} strokeWidth="3"
                        strokeDasharray={`${d} 94.2`} strokeLinecap="round" transform="rotate(-90 18 18)"/>
                </svg>
                <span className="reputation-value" style={{ color: c }}>{score}%</span>
            </div>
        );
    }

    const closeAddOrgSidePanel = () => {
        setShowDownloadReport(false)
    }

    const tooltipContent = (data) => {
        return (
            <div className="d-flex align-items-center gap-2 tooltip-logo">
                <img src={getOrganizationImageUrl(data)} alt="logo" />
                <p>{data?.name}</p>
                <span>{data?.stats?.overall_score?.obtained_score}</span>
            </div>
        )
    }
    

    const tooltipContentmany = (data) => {
        return (
            <>
                {
                    data?.map((value, index)=>{
                        if(index >= 19){
                            return (
                                <div className="d-flex align-items-center gap-2 mb-3 tooltip-logo" key={index}>
                                    <img src={getOrganizationImageUrl(value)} alt="logo" />
                                    <p>{value?.name}</p>
                                    <span>{value?.stats?.overall_score?.obtained_score}</span>
                                </div>
                            )
                        }
                        return null
                    })
                }
            </>
        )
    }

    const getSeverityStatus = (data) => {
        const score = data?.stats?.overall_score?.obtained_score
        if(score < 450) {
            return 'critical'
        } else if (score >= 450 && score < 540) {
            return 'high'
        } else if (score > 540 && score < 719) {
            return 'medium'
        } else {
            return 'low'
        }
    }

    const getPercentage = (data) => {
        const score = data?.stats?.overall_score?.obtained_score;
        if(score < 450) {
            return '50'
        } else if (score >= 450 && score < 540) {
            return '60'
        } else if (score > 540 && score < 719) {
            return '75'
        } else {
            return '90'
        }
    }

    const getGradeClassName = (grade) => {
        if(grade.toLowerCase() === "a+") {
            return 'a-plus'
        } else {
            return grade.toLowerCase()
        }
    }

    // const handlePageChange = (newPage) => {
    //     setListCurrentPage(newPage);
    // };

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const fetchPortfolioRiskList = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&organization_type=portfolio`;        
        const customerId = getloggedInUserType() === "internal" && customerSelectedValue ? `&customer_id=${customerSelectedValue}` : "";
        const queryParams = searchQuery ? `&query=${searchQuery}`: "";
        const url = `${baseUrl}${customerId}${queryParams}`
        dispatch(getPortfolioRiskList(url));
    },[dispatch, currentPage, currentPageSize, customerSelectedValue, searchQuery])

    const fetchPortfolioStatus = useCallback(()=>{
        setStatsLoading(true)
        const url = getloggedInUserType() === "internal" ? `&customer_id=${customerSelectedValue}`: ""
        dispatch(getPortfolioStatus(url))
    },[dispatch, customerSelectedValue])

    
    useEffect(() => {
        if (getloggedInUserType() === "internal" && !customerSelectedValue) return;
        fetchPortfolioRiskList();
    }, [fetchPortfolioRiskList, customerSelectedValue]);

    useEffect(() => {
        if (getloggedInUserType() === "internal" && !customerSelectedValue) return;
        fetchPortfolioStatus();
    }, [fetchPortfolioStatus, customerSelectedValue]);

    // useEffect(()=>{
    //     if(selectedOrganization !== "") {
    //         fetchDomainList()
    //     } else {
    //         dispatch(resetPortfolioDomainList())
    //     }        
    // },[fetchDomainList, selectedOrganization, dispatch])

    useEffect(()=>{
        if(portfolioRiskListResponse != null) {
            setPortfolioList(portfolioRiskListResponse)
            // if(portfolioRiskListResponse?.results?.length > 0) {
            //     setSelectedOrganization(portfolioRiskListResponse?.results[0])
            // } else {
            //     setSelectedOrganization("")
            // }
            setIsLoading(false)
        }
    },[portfolioRiskListResponse])

    useEffect(()=>{
        if(portfolioDomainListResponse !== null) {
            setIsLoading(false)
        }
    },[portfolioDomainListResponse])

    useEffect(()=>{
        if(portfolioStatusResponse !== null) {
            setStatsLoading(false)

            setCriticalList(portfolioStatusResponse?.critical);
            setHighList(portfolioStatusResponse?.high);

            

            const mediumList = portfolioStatusResponse?.medium ?? [];

            setMediumList(mediumList.filter(item =>
                item.stats.overall_score.obtained_score < 638 &&
                item.stats.overall_score.obtained_score >= 540
            ));

            setMediumTwo(mediumList.filter(item =>
                item.stats.overall_score.obtained_score <= 719 &&
                item.stats.overall_score.obtained_score >= 639
            ));

            const lowList = portfolioStatusResponse?.low ?? [];

            setLowList(lowList.filter(item =>
                item.stats.overall_score.obtained_score < 810 &&
                item.stats.overall_score.obtained_score >= 720
            ));

            setMoreThan800(lowList.filter(item =>
                item.stats.overall_score.obtained_score >= 810
            ));          
        }
    },[portfolioStatusResponse])

    return (
        <>
            <div className="scan-info-main-content portfolio-risk-main-content">
                <div className="bg-white-with-shadow p-4">
                    {
                        statsLoading ?
                        <SkeletonLoader type={"line"} count={4} currentPage={"portfolioDashboard"} />
                        :
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="risk-text-level d-flex justify-content-between">
                                {/* <p>High</p> */}
                                <p>Risk Levels</p>
                                {/* <p>Low</p> */}
                            </div>
                            <div className="heat-map-container d-flex gap-3">                                
                                <div className="risk-graph">
                                    <div className="row-first-div d-flex align-items-center main-row-container">
                                        <div className="score-value-div d-flex align-items-center">
                                            <p>0-449</p>
                                        </div>
                                        <div className="row-common-div row-one-one d-flex align-items-center justify-content-around gap-2 p-2">
                                            
                                            {
                                                criticalList?.length > 0 ?
                                                criticalList?.map((data, index)=>{
                                                    if(index <= 19) {
                                                        return (
                                                            <CustomTooltip content={tooltipContent(data)} position="top" key={index}>
                                                                <div className="image">
                                                                    <img src={getOrganizationImageUrl(data)} alt="logo"/>
                                                                </div>
                                                            </CustomTooltip>
                                                        )
                                                    }
                                                    return null
                                                })
                                                :
                                                ""
                                            }
                                            {
                                                criticalList?.length > 19 ?
                                                <CustomTooltip content={tooltipContentmany(criticalList)} position="bottom">
                                                    <div className="additional-container d-flex align-items-center justify-content-center">
                                                        <p>+{criticalList?.length - 19}</p>
                                                    </div>
                                                </CustomTooltip>
                                                :
                                                ""
                                            }
                                        </div>                                
                                    </div>
                                    <div className="row-two-div d-flex align-items-center main-row-container">
                                        <div className="score-value-div d-flex align-items-center">
                                            <p>450-539</p>
                                        </div>
                                        <div className="row-common-div row-two-one d-flex align-items-center justify-content-around gap-2 p-2">
                                            {
                                                highList?.length > 0 ?
                                                highList?.map((data, index)=>{
                                                    if(index <= 19) {
                                                        return (
                                                            <CustomTooltip content={tooltipContent(data)} position="top" key={index}>
                                                                <div className="image">
                                                                    <img src={getOrganizationImageUrl(data)} alt="logo"/>
                                                                </div>
                                                            </CustomTooltip>
                                                        )
                                                    }
                                                    return null
                                                })
                                                :
                                                ""
                                            }
                                            {
                                                highList?.length > 19 ?
                                                <CustomTooltip content={tooltipContentmany(highList)} position="bottom">
                                                    <div className="additional-container d-flex align-items-center justify-content-center">
                                                        <p>+{highList?.length - 19}</p>
                                                    </div>
                                                </CustomTooltip>
                                                :
                                                ""
                                            }
                                        </div>
                                    </div>
                                    <div className="row-three-div d-flex align-items-center main-row-container">
                                        <div className="score-value-div d-flex align-items-center">
                                            <p>540-638</p>
                                        </div>
                                        <div className="row-common-div row-three-one d-flex align-items-center justify-content-around gap-2 p-2">
                                            {
                                                mediumList?.length > 0 ?
                                                mediumList?.map((data, index)=>{
                                                    if(index <= 19) {
                                                        return (
                                                            <CustomTooltip content={tooltipContent(data)} position="top" key={index}>
                                                                <div className="image">
                                                                    <img src={getOrganizationImageUrl(data)} alt="logo"/>
                                                                </div>
                                                            </CustomTooltip>
                                                        )
                                                    }
                                                    return null
                                                })
                                                :
                                                ""
                                            }
                                            {
                                                mediumList?.length > 19 ?
                                                <CustomTooltip content={tooltipContentmany(mediumList)} position="bottom">
                                                    <div className="additional-container d-flex align-items-center justify-content-center">
                                                        <p>+{mediumList?.length - 19}</p>
                                                    </div>
                                                </CustomTooltip>
                                                :
                                                ""
                                            }
                                        </div>
                                    </div>
                                    <div className="row-three-div d-flex align-items-center main-row-container">
                                        <div className="score-value-div d-flex align-items-center">
                                            <p>639-719</p>
                                        </div>
                                        <div className="row-common-div row-three-one d-flex align-items-center justify-content-around gap-2 p-2">
                                            {
                                                mediumTwo?.length > 0 ?
                                                mediumTwo?.map((data, index)=>{
                                                    if(index <= 19) {
                                                        return (
                                                            <CustomTooltip content={tooltipContent(data)} position="top" key={index}>
                                                                <div className="image">
                                                                    <img src={getOrganizationImageUrl(data)} alt="logo"/>
                                                                </div>
                                                            </CustomTooltip>
                                                        )
                                                    }
                                                    return null
                                                })
                                                :
                                                ""
                                            }
                                            {
                                                mediumTwo?.length > 19 ?
                                                <CustomTooltip content={tooltipContentmany(mediumTwo)} position="bottom">
                                                    <div className="additional-container d-flex align-items-center justify-content-center">
                                                        <p>+{mediumTwo?.length - 19}</p>
                                                    </div>
                                                </CustomTooltip>
                                                :
                                                ""
                                            }
                                        </div>
                                    </div>
                                    <div className="row-four-div d-flex align-items-center main-row-container">
                                        <div className="score-value-div d-flex align-items-center">
                                            <p>720-809</p>
                                        </div>
                                        <div className="row-common-div row-four-one d-flex align-items-center justify-content-around gap-2 p-2">
                                            {/* {console.log("test", lowList)} */}
                                            {
                                                lowList?.length > 0 ?
                                                lowList?.map((data, index)=>{
                                                    if(index <= 19) {
                                                        return (
                                                            <CustomTooltip content={tooltipContent(data)} position="top" key={index}>
                                                                <div className="image">
                                                                    <img src={getOrganizationImageUrl(data)} alt="logo"/>
                                                                </div>
                                                            </CustomTooltip>
                                                        )
                                                    }
                                                    return null
                                                })
                                                :
                                                ""
                                            }
                                            {
                                                lowList?.length > 19 ?
                                                <CustomTooltip content={tooltipContentmany(lowList)} position="bottom">
                                                    <div className="additional-container d-flex align-items-center justify-content-center">
                                                        <p>+{lowList?.length - 19}</p>
                                                    </div>
                                                </CustomTooltip>
                                                :
                                                ""
                                            }
                                        </div>
                                    </div>
                                    <div className="row-five-div d-flex align-items-center main-row-container">
                                        <div className="score-value-div d-flex align-items-center">
                                            <p>&gt; 810</p>
                                        </div>
                                        <div className="row-common-div row-five-one d-flex align-items-center justify-content-around gap-2 p-2">
                                            {
                                                moreThan800?.length > 0 ?
                                                moreThan800?.map((data, index)=>{
                                                    if(index <= 19) {
                                                        return (
                                                            <CustomTooltip content={tooltipContent(data)} position="top" key={index}>
                                                                <div className="image">
                                                                    <img src={getOrganizationImageUrl(data)} alt="logo"/>
                                                                </div>
                                                            </CustomTooltip>
                                                        )
                                                    }
                                                    return null
                                                })
                                                :
                                                ""
                                            }
                                            {
                                                moreThan800?.length > 19 ?
                                                <CustomTooltip content={tooltipContentmany(moreThan800)} position="bottom">
                                                    <div className="additional-container d-flex align-items-center justify-content-center">
                                                        <p>+{moreThan800?.length - 19}</p>
                                                    </div>
                                                </CustomTooltip>
                                                :
                                                ""
                                            }
                                        </div>
                                    </div>
                                    <div className="row-six-div d-flex align-items-center main-row-container">
                                        <div className="score-value-div d-flex align-items-center">
                                            <p></p>
                                        </div>
                                        <div className="row-common-div row-five-one d-flex align-items-center justify-content-between gap-2 p-2">
                                            <p className="business-imapct"></p>
                                            <div className="risk-levels d-flex align-items-center gap-4">
                                                <p className="level-txt critical">Critical<span>{portfolioStatusResponse?.critical?.length}</span></p>
                                                <p className="level-txt high">High <span>{portfolioStatusResponse?.high?.length}</span></p>
                                                <p className="level-txt medium">Medium<span>{portfolioStatusResponse?.medium?.length}</span></p>
                                                <p className="level-txt low">Low<span>{portfolioStatusResponse?.low?.length}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    }
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={12}>
                            <div className="bg-white-with-shadow sub-domain-main-container p-3 h-100">
                                <div className="search-header-container d-flex align-items-center gap-3 mb-3">
                                    <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                                        <div className="search-container position-relative">
                                            <span className="position-absolute">{searchIcon()}</span>
                                            <input type="text" 
                                                placeholder="Search" 
                                                value={searchValue} 
                                                onChange={(e)=>{
                                                    setSearchValue(e.target.value)
                                                }}
                                                onFocus={() => setIsSearchFocused(true)}
                                                onBlur={() => setIsSearchFocused(false)}
                                            />
                                        </div>
                                        <button className="search-btn" onClick={onSearch}>Search</button>
                                    </div>
                                </div>
                                {
                                    isLoading ?
                                        <SkeletonLoader type={"line"} count={5} currentPage={"portfolioDashboard"} />
                                    :
                                    <Table className="porfolio-domain-list">
                                        <thead>
                                            <tr>
                                                <th className="organization">Organization</th>
                                                <th className="domain">Domain</th>
                                                <th className="risk-score">Risk Score</th>
                                                {/* <th className="digital-asset">Digital Asset</th> */}
                                                <th className="infra">Infrastructure</th>
                                                <th className="exposure">Exposure</th>
                                                <th className="vulnerable">Vulnerabilities</th>
                                                <th className="dark">Dark Web</th>
                                                <th className="reputation">Backlink Reputation</th>
                                                <th className="business">Business Imapct</th>
                                                <th className="table-action"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                portfoliList?.results?.length > 0 &&
                                                portfoliList?.results?.map((data, index)=>{
                                                    const hasChildren = data.domain_list?.length > 1;
                                                    const isExpanded = !!expanded[data?.organization_id];
                                                    const perPage = childPerPages[data?.organization_id] || DEFAULT_PER_PAGE;
                                                    const fc = isExpanded ? getFilteredChildren(data?.organization_id) : [];
                                                    const totalPages = Math.ceil(fc.length / perPage);
                                                    let page = childPages[data?.organization_id] || 1;
                                                    if (page > totalPages) page = Math.max(1, totalPages);
                                                    const slice = fc.slice((page - 1) * perPage, page * perPage);
                                                    return (
                                                        <Fragment key={index}>
                                                            <motion.tr
                                                                key={index}
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                                            >
                                                                <td>
                                                                    <div className="d-flex align-items-center gap-3">
                                                                        <ExpandToggle hasChildren={hasChildren} expanded={isExpanded} onClick={() => toggleOrg(data?.organization_id)} />                                                                  
                                                                        <p>{data?.name}</p>
                                                                        {hasChildren && <span className="child-count">+{data?.domain_list.length - 1}</span>}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <p>{data?.domain_list[0]?.domain}</p>
                                                                </td>
                                                                <td>
                                                                    <div className={`d-flex align-items-center flex-column gap-2 scan-progress inprogress`}>
                                                                        <h4>{data?.domain_list[0]?.stats?.overall_score?.obtained_score}</h4>
                                                                        <div className={`progress-container ${getSeverityStatus(data?.domain_list[0])}`}> 
                                                                            <div style={{width:`${getPercentage(data.domain_list[0])}%`}}></div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                {/* <td>
                                                                    <p>33</p>
                                                                </td> */}
                                                                <td>
                                                                    <p className={`grade grade-${getGradeClassName(data?.domain_list[0]?.stats?.infrastructure_score?.obtained_rating)}`}>{data?.domain_list[0]?.stats?.infrastructure_score?.obtained_rating}</p>
                                                                </td>
                                                                <td>
                                                                    <p className={`grade grade-${getGradeClassName(data?.domain_list[0]?.stats?.exposure_score?.obtained_rating)}`}>{data?.domain_list[0]?.stats?.exposure_score?.obtained_rating}</p>
                                                                </td>
                                                                <td>
                                                                    <p className={`grade grade-${getGradeClassName(data?.domain_list[0]?.stats?.vulnerability_score?.obtained_rating)}`}>{data?.domain_list[0]?.stats?.vulnerability_score?.obtained_rating}</p>
                                                                </td>
                                                                <td>
                                                                    <p className={`grade grade-${getGradeClassName(data?.domain_list[0]?.stats?.darkweb_score?.obtained_rating)}`}>{data?.domain_list[0]?.stats?.darkweb_score?.obtained_rating}</p>
                                                                </td>
                                                                <td>
                                                                    <ReputationRing score={data?.domain_list[0]?.stats?.backlink_score?.obtained_score} />
                                                                </td>
                                                                <td>
                                                                    <span className={`severity ${getSeverityStatus(data)}`}>{getSeverityStatus(data)}</span>
                                                                </td>
                                                                <td>
                                                                    <p className="table-action" onClick={()=>{
                                                                        navigate(`/scan-info/exposure/dashboard?customer=all&organization=all&domain=${data?.domain_list[0]?.domain}&scanId=${data?.domain_list[0]?.domain.scan_id}`)
                                                                    }}>View Scan <span>{sendIcon()}</span></p>
                                                                    <p className="table-action" onClick={()=>{
                                                                        setSelectedDoamin(data?.domain_list[0])
                                                                        setShowDownloadReport(true)
                                                                    }}>Download <span>{scanHistoryDownloadReportIcon()}</span></p>
                                                                </td>
                                                            </motion.tr>
                                                            {/* Child rows */}
                                                            {isExpanded && slice.map((child, index) => {
                                                                if(index === 0) return null;
                                                                return (
                                                                    <tr className="child-row" key={child?.scan_id}>
                                                                        <td></td>
                                                                        <td>
                                                                            <p>{child?.domain}</p>
                                                                        </td>
                                                                        <td>
                                                                            <div className={`d-flex align-items-center flex-column gap-2 scan-progress inprogress`}>
                                                                                <h4>{child?.stats?.overall_score?.obtained_score}</h4>
                                                                                <div className={`progress-container ${getSeverityStatus(child)}`}> 
                                                                                    <div style={{width:`${getPercentage(child)}%`}}></div> 
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <p className={`grade grade-${getGradeClassName(child?.stats?.infrastructure_score?.obtained_rating)}`}>{child?.stats?.infrastructure_score?.obtained_rating}</p>
                                                                        </td>
                                                                        <td>
                                                                            <p className={`grade grade-${getGradeClassName(child?.stats?.exposure_score?.obtained_rating)}`}>{child?.stats?.exposure_score?.obtained_rating}</p>
                                                                        </td>
                                                                        <td>
                                                                            <p className={`grade grade-${getGradeClassName(child?.stats?.vulnerability_score?.obtained_rating)}`}>{child?.stats?.vulnerability_score?.obtained_rating}</p>
                                                                        </td>
                                                                        <td>
                                                                            <p className={`grade grade-${getGradeClassName(child?.stats?.darkweb_score?.obtained_rating)}`}>{child?.stats?.darkweb_score?.obtained_rating}</p>
                                                                        </td>
                                                                        <td>
                                                                            <ReputationRing score={child?.stats?.backlink_score?.obtained_score} />
                                                                        </td>
                                                                        <td>
                                                                            <span className={`severity ${getSeverityStatus(child)}`}>{getSeverityStatus(child)}</span>
                                                                        </td>
                                                                        <td>
                                                                            <p className="table-action" onClick={()=>{
                                                                                navigate(`/scan-info/exposure/dashboard?customer=all&organization=all&domain=${child?.domain}&scanId=${child?.scan_id}`)
                                                                            }}>View Scan <span>{sendIcon()}</span></p>
                                                                            <p className="table-action" onClick={()=>{
                                                                                setSelectedDoamin(child)
                                                                                setShowDownloadReport(true)
                                                                            }}>Download <span>{scanHistoryDownloadReportIcon()}</span></p>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                            {isExpanded && (
                                                                <ChildPagination
                                                                    orgId={data?.organization_id}
                                                                    filteredChildren={fc}
                                                                    totalAll={data?.domain_list.length}
                                                                    page={page}
                                                                    perPage={perPage}
                                                                    searchVal={childSearch[data?.organization_id] || ""}
                                                                    onPageChange={goToChildPage}
                                                                    onPerPageChange={changePerPage}
                                                                    onSearch={searchDomains}
                                                                />
                                                            )}
                                                        </Fragment>                                                        
                                                    )
                                                }) 
                                            }
                                            {
                                                !isLoading && portfoliList === null &&
                                                <motion.tr
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4 }}
                                                >
                                                    <td colSpan={8}>
                                                        <NoDataFound noDataText={"No data found"} />
                                                    </td>
                                                </motion.tr>                                                
                                            }
                                        </tbody>
                                    </Table>
                                }
                                {portfoliList?.results?.length > 0 && <Pagination
                                    className="pagination-bar"
                                    currentPage={currentPage}
                                    pageSize={currentPageSize}
                                    totalCount={portfoliList?.meta?.total_results}
                                    onPageChange={setCurrentPageandRecordSize}
                                />}
                                {
                                  !isLoading && portfoliList?.results?.length === 0  &&
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <NoDataFound noDataText={portfolioDomainListResponse?.description}/>
                                    </motion.div>
                                }                               
                            </div>
                            <SideModal showSidePanel={showDownloadReport} hideSidePanel={closeAddOrgSidePanel}>
                                {showDownloadReport && <DownloadReport currentPageType={"scanHistory"} domainDetails={selectedDomain} closeDownloadReport={closeAddOrgSidePanel}/>}
                            </SideModal>
                        </Col>
                    </Row>
                </div>
            </div>
        </>      
    )
}


export default PortfolioDashboard;